import Firebase from './Firebase';
import * as firebase from 'firebase/app';
import 'firebase/firestore';

function generateUUID() {
    var d = new Date().getTime();
    if (typeof performance !== 'undefined' && typeof performance.now === 'function'){
        d += performance.now(); //use high-precision timer if available
    }
    return 'xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = (d + Math.random() * 16) % 16 | 0;
        d = Math.floor(d / 16);
        return (c === 'x' ? r : ((r & 0x3) | 0x8)).toString(16);
    });
}

function dataURItoBlob(dataURI) {
  // convert base64 to raw binary data held in a string
  // doesn't handle URLEncoded DataURIs - see SO answer #6850276 for code that does this
  var byteString = atob(dataURI.split(',')[1]);

  // separate out the mime component
  var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0]

  // write the bytes of the string to an ArrayBuffer
  var ab = new ArrayBuffer(byteString.length);

  // create a view into the buffer
  var ia = new Uint8Array(ab);

  // set the bytes of the buffer to the correct values
  for (var i = 0; i < byteString.length; i++) {
      ia[i] = byteString.charCodeAt(i);
  }

  // write the ArrayBuffer to a blob, and you're done
  var blob = new Blob([ab], {type: mimeString});
  return blob;

}

export function postBook(bookData, onProgress){
  return new Promise( (finalResolve, finalReject) => {
    var storage = Firebase.getStorage();
    var storageRef = storage.ref();
    var db = Firebase.getFirestore();

    var bookUUID = generateUUID();

    // upload all pictures to storage
    var picUploadPromises = bookData.pictures.map( (pic, ind) => (
      new Promise( (resolve, reject) => {
        var iblob = dataURItoBlob(pic.picture);
        var fileExtension = iblob.type.split("/")[1];
        var imgpath = `books/${bookUUID}/${ind}.${fileExtension}`;
        var imgref = storageRef.child(imgpath);
        imgref.put(iblob).then((snapshot) => {
          pic.url = snapshot.ref.toString();
          resolve();
        }).catch((err) => {reject(err)});
      })
    ));

    Promise.all(picUploadPromises).then( (values) => {
      var dbPromises = [];

      // submit the book to firestore
      dbPromises.push(db.collection('books').doc(bookUUID).set({
        name: bookData.name,
        email: bookData.email,
        telephone: bookData.telephone,
        date: firebase.firestore.Timestamp.now()
      }));

      // add pages data to firestore
      var pic_collection = db.collection('books').doc(bookUUID).collection('pictures');
      dbPromises += bookData.pictures.map( (pic, ind) => {
        return pic_collection.doc(ind + '').set({
          people: pic.people,
          description: pic.description,
          picture: pic.url
        });
      });

      Promise.all(dbPromises)
        .then((values) => finalResolve(values))
        .catch((err) => finalReject(err));
    }).catch((err) => finalReject(err));
  });
}
